<template>
  <div>
    <span v-if="row.localPrescriptions.length === 1 && row.localPrescriptionsCenter">{{ getSourceName() }}</span>
    <el-select v-else :value="selectedVal" @input="val => selectSource(val)" placeholder="请选择" clearable>
      <el-option v-for="item in row.localPrescriptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'SourceSelect',
  props: {
    row: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState('shopManagement', ['sourceList']),
    ...mapGetters(['getchangeSetingList']),
    selectedVal() {
      const { sourceList } = this;
      const { id, localPrescriptionsCenter } = this.row;
      if (!sourceList[id]) {
        this.$store.commit('shopManagement/UPDATE_SOURCE_LIST', { id, val: localPrescriptionsCenter });
      }
      return sourceList[id] ? sourceList[id].val : localPrescriptionsCenter;
    }
  },
  methods: {
    getSourceName() {
      const { localPrescriptions } = this.row;
      const prescription = localPrescriptions.find(p => p.id == this.selectedVal);
      console.log(prescription, 'prescription');
      if (prescription) {
        return prescription.name;
      }
      return '';
    },
    selectSource(val) {
      const {
        id,
        remotePharmacistStatus,
        storePharmacistStatus,
        faceStatus,
        dispenseStatus,
        dispatchStatus,
        diagnoseBeforeAskStatus,
        localPrescriptionsCenter = ''
      } = this.row;
      const hasChanged = this.getchangeSetingList.some(l => l.id == id);
      if (!hasChanged && val !== '') {
        this.$store.commit('shopManagement/UPDATESETINGLIST', {
          ...this.row,
          FEremote: remotePharmacistStatus,
          FEpha: storePharmacistStatus,
          FEface: faceStatus,
          FElpcStatus: Number(Boolean(localPrescriptionsCenter)),
          FEdispenseStatus: dispenseStatus,
          FEdispatchStatus: dispatchStatus,
          FEDiagnoseBeforeAskStatus: diagnoseBeforeAskStatus
        });
      }
      this.$store.commit('shopManagement/UPDATE_SOURCE_LIST', { id, val, isEdit: true });
    }
  }
};
</script>

<style lang="scss" scoped></style>
